import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import {
  HbrDropUpIcon,
  HbrDropdownIcon,
  HbrShareIcon,
} from "../newComponents/Mycustomsvgicons";
import { insertBookAnalytics } from "../newComponents/GeneralClasses";
import { ConstVariables } from "../newComponents2/ConstantVariables";

const BookContent = ({
  bookid,
  bookTitle,
  bookImage,
  bookAuthor,
  authorpic,
  summary,
  reads,
  shares,
  bookmarks,
  rate,
  totalBooks,
  bookIndex,
  handleReview,
}) => {
  const [showAuthorinfo, setShowAuthorinfo] = useState(false);
  const [showSummary, setShowsummary] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const shareBook = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: `${bookTitle}`,
          text: `Check out this book and your life will never be the same. Very inspiring and crucial for our eternal life.`,
          // url: `https://horemowbookreaderlite.web.app/hrmwenglishbooks/${bookTitle}/${bookid}`,
          url: `/hbrbooks?language=english&booktitle=${bookTitle}&bookid=${
            bookid && bookid !== "" ? bookid : "hbrwebbook404"
          }`,
        });
        insertBookAnalytics(bookTitle, ConstVariables.SHARES);
      } catch {
        console.error("failed to share book.");
      }
    } else {
      console.error("sharing navigator not available");
    }
  };

  const handleRead = () => {
    insertBookAnalytics(bookTitle, ConstVariables.READS);
    navigate(
      `/hbrbooks?language=english&booktitle=${bookTitle}&bookid=${
        bookid && bookid !== "" ? bookid : "hbrwebbook404"
      }`,
      { state: { from: location.pathname } },
    );
  };

  return (
    <div className="bookcontainerdiv">
      <div className="frontBookView flex-column2">
        <h4>{`${bookIndex}/${totalBooks}`}</h4>
        <h3 style={{ color: "#f1356d", marginTop: "8px" }}>{bookTitle}</h3>

        <div className="bookinfo flex-spacebetween" style={{ width: "100%" }}>
          <div className="flex-column1" style={{ width: "50%", gap: "5px" }}>
            <div
              className="authormenu flex-row2"
              onClick={() => setShowAuthorinfo((prev) => !prev)}
            >
              <img src={authorpic} alt="" />

              <h4>About Author</h4>
              {!showAuthorinfo ? (
                <HbrDropdownIcon
                  width="1.7em"
                  height="1.7em"
                  fillColour="black"
                />
              ) : (
                <HbrDropUpIcon
                  width="1.7em"
                  height="1.7em"
                  fillColour="black"
                />
              )}

              {showAuthorinfo && (
                <div className="authorinfocontent">
                  <pre>{bookAuthor}</pre>
                </div>
              )}
            </div>

            <div
              className="summarymenu flex-row2"
              onClick={() => setShowsummary((prev) => !prev)}
            >
              <h4>Book Summary</h4>
              {!showSummary ? (
                <HbrDropdownIcon
                  width={"2em"}
                  height={"2em"}
                  fillColour={"black"}
                />
              ) : (
                <HbrDropUpIcon
                  width={"2em"}
                  height={"2em"}
                  fillColour={"black"}
                />
              )}

              {showSummary && (
                <div className="summarycontent">
                  <pre>{summary}</pre>
                </div>
              )}
            </div>
          </div>

          <div
            className="flex-column2"
            style={{ width: "40%", gap: "8px", marginTop: "8px" }}
          >
            {shares > 0 && (
              <div className="flex-row2">
                <h4>Shares:</h4>
                <p style={{ color: "red", fontWeight: "bold" }}>{shares}</p>
              </div>
            )}

            {reads > 0 && (
              <div className="flex-row2">
                <h4>Reads:</h4>
                <p style={{ color: "red", fontWeight: "bold" }}>{reads}</p>
              </div>
            )}
            {bookmarks > 0 && (
              <div className="flex-row2">
                <h4>Bookmarks:</h4>
                <p style={{ color: "red", fontWeight: "bold" }}>{bookmarks}</p>
              </div>
            )}
            {rate > 0 && (
              <div className="flex-row2">
                <h4>Rate:</h4>
                <p style={{ color: "red", fontWeight: "bold" }}>{rate}</p>
              </div>
            )}
          </div>
        </div>

        <button id="writereview" onClick={() => handleReview(bookTitle)}>
          write a Review
        </button>

        <img src={bookImage} alt="book Cover" />
        <div className="frontbookbottom flex-spacebetween">
          <button onClick={() => handleRead()}>Read</button>

          <HbrShareIcon
            width="1.7em"
            height="1.7em"
            fillColour="black"
            handleClick={() => shareBook()}
          />
        </div>
      </div>
    </div>
  );
};
export default BookContent;
